<div class="modelhub__header__wapper" >
    <div class="container-fluid">
        <div class="row pt-2 pb-2">
            <div class="col-sm-4">
                <a class="navbar-brand" href="admin/dashboard">
                    <span class="big_logo" >
                        <img src="../../../../assets/images/Model6_logo.png" style="width: 39%;" class="logo_css big_logo"
                             />
                    </span>

                </a>
            </div>
             <div class="col-sm-8 align-right header__right__section">
                

                    <ul class="nav">
                        <li class="nav-item align-self-center modelHub__Name">

                            <h3><b>{{userName}}</b></h3>
                            <a class="modelHub__Company" style="text-decoration: none;">{{account__Name}}</a>
                        </li>
                        <li class="nav-item align-self-center align-menu newtext">
                            <div ngbDropdown class="d-inline-block  " style=" padding-right: 5px;">
                                <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle style="border: none;">
                                    <!-- <img src="assets/images/menu_icon.svg" alt="Responsive image" /> -->
                               <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C34.1506 0 44 9.8494 44 22C44 34.1506 34.1506 44 22 44C9.8494 44 0 34.1506 0 22C0 9.8494 9.8494 0 22 0ZM11.7333 13.9333C11.3443 13.9333 10.9713 14.0879 10.6962 14.3629C10.4212 14.638 10.2667 15.011 10.2667 15.4C10.2667 15.789 10.4212 16.162 10.6962 16.4371C10.9713 16.7121 11.3443 16.8667 11.7333 16.8667H32.2667C32.6557 16.8667 33.0287 16.7121 33.3038 16.4371C33.5788 16.162 33.7333 15.789 33.7333 15.4C33.7333 15.011 33.5788 14.638 33.3038 14.3629C33.0287 14.0879 32.6557 13.9333 32.2667 13.9333H11.7333ZM14.3 20.5333C13.911 20.5333 13.538 20.6879 13.2629 20.9629C12.9879 21.238 12.8333 21.611 12.8333 22C12.8333 22.389 12.9879 22.762 13.2629 23.0371C13.538 23.3121 13.911 23.4667 14.3 23.4667H29.7C30.089 23.4667 30.462 23.3121 30.7371 23.0371C31.0121 22.762 31.1667 22.389 31.1667 22C31.1667 21.611 31.0121 21.238 30.7371 20.9629C30.462 20.6879 30.089 20.5333 29.7 20.5333H14.3ZM16.5 27.1333C16.111 27.1333 15.738 27.2879 15.4629 27.5629C15.1879 27.838 15.0333 28.211 15.0333 28.6C15.0333 28.989 15.1879 29.362 15.4629 29.6371C15.738 29.9121 16.111 30.0667 16.5 30.0667H27.5C27.889 30.0667 28.262 29.9121 28.5371 29.6371C28.8121 29.362 28.9667 28.989 28.9667 28.6C28.9667 28.211 28.8121 27.838 28.5371 27.5629C28.262 27.2879 27.889 27.1333 27.5 27.1333H16.5Z" fill="#ef2917"/>
</svg>

                                </button>
                               
                              
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
                                    class="header-dropdown triangle-up">
                                    <button ngbDropdownItem class="privacy-policy" (click)="open(changePassword)" ><img
                                            src="assets/images/password.svg" class="logout-icon"
                                            alt="Responsive image " />Change Password</button>
                                    
                                    <a href="https://www.bay6.ai/privacy-policy/" target="_blank" style="text-decoration: none;">
                                        <button ngbDropdownItem>
                                            <img src="assets/images/privacy_policy.svg" class="logout-icon"
                                                alt="Responsive image " />
                                            Privacy Policy
                                        </button>
                                    </a>
                                    
                                 

                                    <button ngbDropdownItem class="customer-care" (click)="handleEmailClick()">
                                        <img src="assets/images/support.svg" class="logout-icon"
                                            alt="Responsive image " />Support Email
                                       
 <div class="supportEmail">{{email}}</div>
                                           
                                       
                                    </button>
                                </div>
                            </div>
                        </li>
                        
                        <li class="nav-item align-self-end">
                            <button class="logout" (click)="logout()" >
                                <img src="../../../../assets/images/logout_ic.svg" class="logout-icon"
                                    alt="Responsive image " />Logout
                            </button>
                        </li>
                    </ul>
                

            </div>
        </div>
    </div>
<app-menu-header></app-menu-header>

</div>

<ng-template #changePassword let-modal>
<div class="modal-header"> <span class="header">Change Password</span>
    <img src="assets/images/close_icon.svg" style="width:20px; height:20px; cursor:pointer" alt
       (click)="closeModal()"  />
</div>
 <div class="modal-body reset-password">
        <form class="row mr-1" [formGroup]="changePasswordForm" >
        @for(field of chnages_password_fields;track field){
        <div [class]="field.column" class="form-group-padding" style="margin-bottom: -10px !important;">
            <app-dynamic-form-builder  [field]="field"
                [form]="changePasswordForm"></app-dynamic-form-builder>
        </div>
        }
    </form>
      <div class="row">
                <div class="col-sm-12">
                    <div class="d-flex justify-content-center w-100 mt-1">
                          <button type="button" class="btn btn-form-submit-cancel ml-2" (click)="closeModal()">
                            Cancel
                        </button>&nbsp;&nbsp;
                        <button type="button" class="btn btn-form-submit ml-2" [disabled]="!changePasswordForm.valid" (click)="submitPassword()">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
    </div>
</ng-template>
